<template>
  <div id="app" class="home">
    <!--<div id="nav">
      <router-link to="/">Home</router-link> |
      <router-link to="/about">About</router-link>
    </div>-->

    <!--<router-view/>-->


    <!--<app-home></app-home>-->


    <!--<AppHeader v-bind:headerindex="headerindex" @wentToSecond="headerindex = $event"></AppHeader>

    <AppQuestion></AppQuestion>

    <AppFooter></AppFooter>-->


    <!--<img alt="Vue logo" src="../assets/logo.png">
    <p>Parent view/component Home. Sends data</p>
    <button @click="changeName">Change my name in Testcomponent</button>
    <p>Namnet som ändras: {{ personname }}</p>

    <HelloWorld msg="Welcome to Your Vue.js App"/>
    <Testcomponent v-bind:personname="personname" @nameWasReset="personname = $event"/>-->


      <!--<header>
        <h1><span class="header-top">Interview Question</span>
        <span class="header-number">{{ headerindex }}</span></h1>
      </header>-->


      <AppHeader
        v-bind:indexC="indexP"
        v-bind:headernumberC="headernumberP"
        v-bind:class="{ 'hide-header' : hideHeader }"></AppHeader>

      <transition name="slideInRight">
        <!--https://codesandbox.io/s/vue-template-w3iem Om man vill använda animate.css:-->
      <!--<transition name="custom-classes-transition" enter-active-class="animated slideInRight" leave-active-class="animated slideOutLeft">-->
      <component :is="selectedComponent"
                  v-bind:indexC="indexP"
                  @update-answer-one="updateAnswerOne" v-bind:answerOneC="answerOneP"
                  @update-answer-two="updateAnswerTwo" v-bind:answerTwoC="answerTwoP"
                  @update-answer-three="updateAnswerThree" v-bind:answerThreeC="answerThreeP"
                  @enable-button="updateButton" v-bind:hasAnsweredC="hasAnswered"
                  @update-answer-four="updateAnswerFour" v-bind:answerFourC="answerFourP"
                  @update-answer-five="updateAnswerFive" v-bind:answerFiveC="answerFiveP"
                  @enter-pressed-emit="updateOnEnter"
                  @data-string="goWrite"
                  @run-go-fetch="goFetch"
                  >
        <p>App is loading...</p>
      </component>
      </transition>


      <!--<button @click="goToSecond">answer</button>-->
      <!--<button @click="goToSecond(); sendAnswer(); isDisabled();" :disabled="!hasAnswered">{{ this.indexP % 2 === 0 ? `next question, please!` : `answer` }}</button>-->
      <div class="button-holder">
      <button @click="goToSecond(); isDisabled(); goFetch(); updateButton(); hideLast(); hideLastHeader()"
              v-bind:hasAnsweredC="hasAnswered"
              :disabled="!hasAnswered"
              v-bind:class="{ 'hide-button' : hideButton }"
              v-on:keyup.enter="goToSecond(); isDisabled(); updateButton(); hideLast();"
              >{{ this.indexP % 2 === 0 ? `next question, please!` : `answer` }}</button></div>



      <footer>
        <transition name="slideInUp" mode="out-in" appear>
        <p v-if="selectedComponent == 'AppQuestion'" key="1">Because this is a classic.</p>
        <p v-else-if="selectedComponent == 'AppQuestion2'" key="2">Child’s play, really!</p>
        <p v-else-if="selectedComponent == 'AppQuestion3'" key="3">Because it’s important to speak the language.</p>
        <p v-else-if="selectedComponent == 'AppQuestion4'" key="4">Tech is my native language.</p>
        <p v-else-if="selectedComponent == 'AppQuestion5'" key="5">Do you have an eye for design &amp; pixel perfection?</p>
        <p v-else-if="selectedComponent == 'AppQuestion6'" key="6">The color of success is my favorite color!</p>
        <p v-else-if="selectedComponent == 'AppQuestion7'" key="7">You should know this stuff!</p>
        <p v-else-if="selectedComponent == 'AppQuestion8'" key="8">I never use Google, it's all in my head</p>
        <p v-else-if="selectedComponent == 'AppQuestion9'" key="9">Do you have a plan?</p>
        <p v-else-if="selectedComponent == 'AppQuestion10'" key="10">Made with <span class="vuelove"><span class="visually-hidden">Vue love</span></span> by <a href="https://twitter.com/fridanyvall" title="@FridaNyvall">Frida</a> @<a href="https://www.redonion.se" title="Visit redonion.se">redonion</a></p>
        </transition>
      </footer>

  </div>
</template>


<script>
/* import AppHome from '@/views/Home.vue';
export default {
  components: {
    AppHome
  }
}; */

// @ is an alias to /src
// import HelloWorld from '@/components/HelloWorld.vue';
// import Testcomponent from '@/components/Testcomponent.vue';
import AppHeader from '@/components/AppHeader.vue';
import AppQuestion from '@/components/AppQuestion.vue';
import AppQuestion2 from '@/components/AppQuestion2.vue';
import AppQuestion3 from '@/components/AppQuestion3.vue';
import AppQuestion4 from '@/components/AppQuestion4.vue';
import AppQuestion5 from '@/components/AppQuestion5.vue';
import AppQuestion6 from '@/components/AppQuestion6.vue';
import AppQuestion7 from '@/components/AppQuestion7.vue';
import AppQuestion8 from '@/components/AppQuestion8.vue';
import AppQuestion9 from '@/components/AppQuestion9.vue';
import AppQuestion10 from '@/components/AppQuestion10.vue';
// import AppFooter from '@/components/AppFooter.vue';



export default {
  name: 'home',
  components: {
    // HelloWorld,
    // Testcomponent,
    AppHeader,
    AppQuestion,
    AppQuestion2,
    AppQuestion3,
    AppQuestion4,
    AppQuestion5,
    AppQuestion6,
    AppQuestion7,
    AppQuestion8,
    AppQuestion9,
    AppQuestion10
    // AppFooter
    // man kan även skriva 'new-component-name' : Testcomponent om man vill använda ett nytt namn och få en garanterat unik selector till sin template
  },
  data: function () {
    return {
      indexP: 1, // fråge index
      headernumberP: 1, // header index
      selectedComponent: 'AppQuestion',
      // answerOneP: 0 // svaret på fråga 1
      answerOneP: { // defaultsvar på defaultval
        ball: 'tennis',
        vehicle: 'jumbojet',
        answer: '1174496'
      }, // svaret på fråga 1
      answerTwoP: {
        binary: null,
        answer: 'No binary',
        error: 1
      },
      // answerThreeP: '#ffffff'
      answerThreeP: { // måste ha default för att det inte ska bli tomt om man väljer default vit
        colorInput: '#ffffff',
        textColor: '#000'
      },
      answerFourP: {},
      answerFiveP: 'backpacking',
      hasAnswered: true,
      hideButton: false, // ,
      // enterPressed: false
      hideHeader: false,
      dataStringP: '',
      results: []
    };
  },
  methods: {
    goWrite: function (emittedvalue) {
      this.dataStringP = emittedvalue;
    },
    goFetch: function () {
      // console.log('goFetch');
      if (this.indexP === 8 || this.indexP === 7) {
        const searchText = 'https://en.wikipedia.org/w/api.php?action=query&format=json&prop=info%7Cextracts&explaintext&generator=search&exsentences=1&exlimit=10&exintro=1&gsrnamespace=0&gsrlimit=1&origin=*&gsrsearch=';

        this.$http.get(searchText + encodeURIComponent(this.dataStringP))
          .then(response => {
          // console.log('sdf ' + response.json());
            return response.json();
          })
          .then(data => {
            // console.log('data: ' + data);
            this.results = data.query.pages;

            // https://stackoverflow.com/questions/983267/how-to-access-the-first-property-of-an-object-in-javascript
            const myresults = this.results[Object.keys(this.results)[0]];

            // this.$emit('update-answer-four', myresults);
            this.answerFourP = myresults;

            // this.$emit('enable-button', true);
            this.updateButton(true);
            return myresults;
          })
          .catch(() => console.log('Enter a text.'));
      }
    },
    /*  goFetchEnter: function (emittedvalue) {
      const searchText = 'https://en.wikipedia.org/w/api.php?action=query&format=json&prop=info%7Cextracts&explaintext&generator=search&exsentences=1&exlimit=10&exintro=1&gsrnamespace=0&gsrlimit=1&origin=*&gsrsearch=';

      this.$http.get(searchText + encodeURIComponent(this.dataStringP))
        .then(response => {
          // console.log('sdf ' + response.json());
          return response.json();
        })
        .then(data => {
          console.log('data: ' + data);
          this.results = data.query.pages;

          // https://stackoverflow.com/questions/983267/how-to-access-the-first-property-of-an-object-in-javascript
          const myresults = this.results[Object.keys(this.results)[0]];

          // this.$emit('update-answer-four', myresults);
          this.answerFourP = myresults;

          // this.$emit('enable-button', true);
          this.updateButton(true);
          return myresults;
        })
        .catch(() => console.log('An error has occurred.'));
    },
    sendAnswer: function () {
      console.log('sendAnswer');
    }, */
    // metod i parent bestämmer vad som ska hända med headerindexC som är bundet till headerindexP
    goToSecond: function () { // för att gå till fråga 2
      if ((this.indexP <= 9) && (this.indexP % 2 === 0)) { // det är ett jämnt tal
        this.indexP++;
        this.selectedComponent = 'AppQuestion' + this.indexP;
        this.headernumberP++;
      } else if (this.indexP <= 9) {
        this.indexP++;
        this.selectedComponent = 'AppQuestion' + this.indexP;
      }
      // this.$router.push('/about');
      // console.log(this.headerindexP);
    },
    updateAnswerOne: function (emittedvalue) {
      this.answerOneP = emittedvalue;
      // console.log('From updateAnswerOne in Home.vue: emittedvalue is: ' + emittedvalue);
      // console.log('From updateAnswerOne in Home.vue:  answerOneP is: ' + this.answerOneP);
      return emittedvalue;
    },
    updateAnswerTwo: function (emittedvalue) {
      this.answerTwoP = emittedvalue;
      // console.log('From updateAnswerTwo in Home.vue: emittedvalue is: ' + emittedvalue);
      // console.log('From updateAnswerTwo in Home.vue:  answerTwoP is: ' + this.answerTwoP);
      return emittedvalue;
    },
    updateAnswerThree: function (emittedvalue) {
      this.answerThreeP = emittedvalue;
      // console.log('From updateAnswerThree in Home.vue: emitted value is ' + emittedvalue);
      // console.log('From updateAnswerThree in Home.vue: answerThreeP is ' + this.answerThreeP);
      return emittedvalue;
    },
    updateAnswerFour: function (emittedvalue) {
      this.answerFourP = emittedvalue;
      // console.log('From updateAnswerFour in Home.vue: emitted value is ' + emittedvalue);
      // console.log('From updateAnswerFour in Home.vue: answerFourP is ' + this.answerFourP);
      return emittedvalue;
    },
    updateAnswerFive: function (emittedvalue) {
      this.answerFiveP = emittedvalue;
      // console.log('From updateAnswerFive in Home.vue: emitted value is ' + emittedvalue);
      // console.log('From updateAnswerFive in Home.vue: answerFiveP is ' + this.answerFiveP);
      return emittedvalue;
    },
    updateOnEnter: function (emittedvalue) {
      if (emittedvalue === true && this.indexP === 3 && this.answerTwoP.error === 0) {
        // this.enterPressed = emittedvalue;
        // this.updateAnswerTwo();
        // console.log('---> updateOnEnter in Home.vue, enterPressed is: ' + this.enterPressed);
        // console.log('---> updateOnEnter in Home.vue, enterPressed is: ' + emittedvalue);

        this.goToSecond();
        // this.hideButton = false;
        // this.hasAnswered = true;
        // this.isDisabled();
        // this.updateButton();
      } else if (emittedvalue === true && this.indexP === 7) {
        // console.log('---> updateOnEnter 4 in Home.vue, enterPressed is: ' + emittedvalue);
        this.goToSecond();
      }
    },
    updateButton: function (emittedvalue) {
      // inget emitted value finns
      // if ((this.answerTwoP.error === 1 && this.indexP === 3) || (this.indexP === 7 && Object.getOwnPropertyNames(this.answerFourP).length !== 0)) {
      if ((this.answerTwoP.error === 1 && this.indexP === 3) || (this.indexP === 7 && Object.getOwnPropertyNames(this.answerFourP).length === 0)) {
        return this.hasAnswered;
      } /* emitted value finns */ else if ((this.answerTwoP.error === 0 && this.indexP === 3) || (this.indexP === 7 && Object.getOwnPropertyNames(this.answerFourP).length !== 0)) {
        this.hasAnswered = emittedvalue;
        // console.log('updateButton in Home.vue: ' + emittedvalue);
        // this.isDisabled();
        return emittedvalue;
      } // om man står i appquestion7
    },
    isDisabled: function () { // lyssnar bara på första klick, uppdaterar inte dynamiskt när data uppdateras. Måste använda v-model? Använder ju även watch på onkeyup i en annan fil. Kanske kan uppdatera värdet på hasAnswered därifrån?
      // if (this.indexP === 3) {
      if ((this.answerTwoP.error === 0 && this.indexP === 3) || (this.indexP === 7 && Object.getOwnPropertyNames(this.answerFourP).length === 0)) {
        // console.log('isDisabled in Home.vue: ' + 'true');
        return !this.hasAnswered; //! this.hasAnswered;
      } else if ((this.answerTwoP.error === 1 && this.indexP === 3) || (this.indexP === 7 && Object.getOwnPropertyNames(this.answerFourP).length !== 0)) { // if (this.answerTwoP.error === 0 && this.indexP === 3) {
        // this.hasAnswered = false;
        this.hasAnswered = false;
        // console.log('isDisabled in Home.vue: ' + 'false');
        return this.hasAnswered; // this.hasAnswered;
      }
    },
    hideLast: function () { // när man befinner sig på sista steget, this.indexP === 10, dölj knappen
      if (this.indexP === 10) {
        this.hideButton = true;
      }
    },
    hideLastHeader: function () {
      if (this.indexP === 10) {
        this.hideHeader = true;
      }
    }
  }
};
</script>


<style lang="scss">
  // om denna style tag tas bort tas inte globala styles med!
</style>

<style lang="scss" scoped>
//Det går bra att använda variabler från _variables.scss här eftersom _variables.scss är importerad i screen.scss

/* #nav {
  padding: 30px;
  a {
    font-weight: bold;
    color: #2c3e50;
    &.router-link-exact-active {
      color: #42b983;
    }
  }
} */

</style>